import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AuthClient, ResendVerificationEmailRequest } from '@app/clients/client.generated';


@Injectable()
export class AccountLoginService {

    constructor(
        private authClient: AuthClient
    ) { }

    resendEmail(email: string) {
        const request = new ResendVerificationEmailRequest({
            email: email
        });
        return this.authClient.resendVerificationEmail(request);
    }
}
